// Auto generated file, do not manually modify!
// com.hotpads.usermanagement.api.web.user.bvl.UmcApplicationManagerApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UmcApplicationPermissionDetails,
  UmcApplicationPermissionDetailsRequestDto,
  UmcApplicationPermissionDetailsResultDto,
} from '../..';

export const UmcApplicationManagerApiHandler_dismissPermissionRequests_Path = '/api/web/bvl/dismissPermissionRequests';

/**
 * Dismiss permission requests for the current user's company
 */
export const UmcApplicationManagerApiHandler_dismissPermissionRequests = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: UmcApplicationManagerApiHandler_dismissPermissionRequests_Path,
      method: 'POST',
      contextPath: '/user-management',
    },
    client,
  );
};

export const UmcApplicationManagerApiHandler_getUserApplicationPermissionDetails_Path =
  '/api/web/bvl/getUserApplicationPermissionDetails';

export const UmcApplicationManagerApiHandler_getUserApplicationPermissionDetails = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UmcApplicationPermissionDetails>(
    {
      endpoint: UmcApplicationManagerApiHandler_getUserApplicationPermissionDetails_Path,
      method: 'GET',
      contextPath: '/user-management',
    },
    client,
  );
};

export const UmcApplicationManagerApiHandler_getUserApplicationPermissionDetailsV2_Path =
  '/api/web/bvl/getUserApplicationPermissionDetailsV2';

export const UmcApplicationManagerApiHandler_getUserApplicationPermissionDetailsV2 = (
  postData: UmcApplicationPermissionDetailsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UmcApplicationPermissionDetailsRequestDto,
    UmcApplicationPermissionDetailsResultDto
  >(
    {
      endpoint: UmcApplicationManagerApiHandler_getUserApplicationPermissionDetailsV2_Path,
      method: 'POST',
      contextPath: '/user-management',
      postData: postData,
    },
    client,
  );
};
